module.exports = __webpack_public_path__ + "static/media/a4.9d0bc2e2.jpg";